<!-- Rendered in the app header's center slot (HeaderContentService), not in
     this page's own layout — bindings still resolve against this component. -->
<ng-template #headerMenu>
    <div class="header-page-actions">
        <div class="ordering-switch">
            <span class="ordering-switch-label">Ordering</span>
            <dx-switch
                [disabled]="dataLoading || ordersLoading"
                [value]="orderingMode"
                hint="Toggle ordering mode — enter order quantities per product"
                (onValueChanged)="onOrderingSwitchChanged($event)"
            ></dx-switch>
        </div>
        @if (orderingMode) {
        <dx-button
            [disabled]="
                dataLoading ||
                ordersBusy ||
                !ordersLoaded ||
                typedLineCount === 0
            "
            stylingMode="contained"
            icon="save"
            text="Save Order ({{ typedLineCount }} items)"
            hint="Create a purchase order from the entered quantities"
            (onClick)="openSaveOrderPopup()"
        ></dx-button>
        <dx-drop-down-button
            [disabled]="ordersBusy || pausedTemp.length === 0"
            icon="clock"
            text="Paused ({{ pausedTemp.length }})"
            hint="Items paused for now — click one to restore it"
            [items]="pausedTempMenuItems"
            displayExpr="text"
            [dropDownOptions]="pausedMenuDropDownOptions"
            (onItemClick)="onPausedTempMenuClick($event)"
        ></dx-drop-down-button>
        }
        <dx-button
            [disabled]="orderSaving"
            stylingMode="contained"
            icon="lock"
            text="Long-term ({{ pausedLong.length }})"
            hint="Items parked indefinitely and why"
            (onClick)="openLongTermPage()"
        ></dx-button>
        <dx-button
            [disabled]="ordersLoading"
            stylingMode="contained"
            icon="bulletlist"
            text="Orders ({{ openOrderCount }})"
            hint="Open / completed purchase orders"
            (onClick)="openOrdersPopup()"
        ></dx-button>
    </div>
</ng-template>

<div class="dx-card padding-content">
    <div
        style="
            display: flex;
            flex-wrap: wrap;
            gap: 20px 10px;
            padding: 10px 10px 10px 10px;
            align-items: baseline;
        "
    >
        <div id="calcPeriodField">
            <dx-number-box
                [disabled]="dataLoading"
                [showSpinButtons]="false"
                format="#,##0 Days"
                [min]="30"
                [max]="360"
                label="Calc. Period"
                labelMode="floating"
                [(value)]="calculationDays"
                [width]="100"
                (onEnterKey)="loadReorderingData()"
            ></dx-number-box>
        </div>
        <div id="leadTimeField">
            <dx-number-box
                [disabled]="dataLoading"
                [showSpinButtons]="false"
                format="#,##0 Days"
                [min]="2"
                [max]="360"
                label="Reordering Lead Time"
                labelMode="floating"
                [(value)]="reorderingLeadTimeDays"
                [width]="150"
                (onEnterKey)="loadReorderingData()"
            ></dx-number-box>
        </div>
        <div id="demandForField">
            <dx-number-box
                [disabled]="dataLoading"
                [showSpinButtons]="false"
                format="#,##0 Days"
                [min]="2"
                [max]="360"
                label="Demand for"
                labelMode="floating"
                [(value)]="demandForDays"
                [width]="100"
                (onEnterKey)="loadReorderingData()"
            ></dx-number-box>
        </div>

        <div class="class-filter" style="margin-left: auto">
            <span class="class-filter-label" id="abcClassInfo"
                >ABC Class <i class="dx-icon-info"></i
            ></span>
            <dx-button-group
                [items]="classFilterItems"
                keyExpr="text"
                selectionMode="multiple"
                stylingMode="outlined"
                hint="Filter the table to the selected ABC classes (none selected = show all)"
                [disabled]="dataLoading"
                [(selectedItemKeys)]="selectedClassFilters"
                (onSelectionChanged)="onFilterSelectionChanged()"
            ></dx-button-group>
        </div>
        <div style="margin-right: auto">
            <dx-drop-down-button
                icon="filter"
                hint="More filters"
                [disabled]="dataLoading"
                [dropDownOptions]="{ width: 'auto' }"
                dropDownContentTemplate="filterMenu"
            >
                <div *dxTemplate="let data of 'filterMenu'" class="filter-menu">
                    <dx-check-box
                        [disabled]="dataLoading"
                        [(value)]="hideDesisted"
                        (onValueChanged)="onFilterSelectionChanged()"
                        text="Hide desisted products ({{
                            desistedItemCount
                        }}&nbsp;items)"
                    ></dx-check-box>
                </div>
            </dx-drop-down-button>
        </div>
        <div>
            <dx-select-box
                [width]="150"
                [items]="viewSelection.doc.views"
                valueExpr="id"
                displayExpr="name"
                label="View"
                labelMode="floating"
                hint="ชุดคอลัมน์ที่แสดง"
                [value]="viewSelection.activeId"
                (onValueChanged)="onColumnViewPicked($event)"
            ></dx-select-box>
        </div>
        @if (orderingMode) {
        <div>
            <dx-select-box
                [disabled]="dataLoading"
                [width]="240"
                [items]="supplierShopItems"
                valueExpr="value"
                displayExpr="text"
                placeholder="All 1688 shops"
                [showClearButton]="true"
                hint="Work through one 1688 shop at a time"
                [(value)]="selectedSupplierShop"
                (onValueChanged)="onFilterSelectionChanged()"
            ></dx-select-box>
        </div>
        }
        <div>
            <dx-button
                [disabled]="orderSaving"
                stylingMode="contained"
                icon="link"
                text="1688"
                hint="ตรวจและแก้ข้อมูล 1688"
                (onClick)="openSupplierPage()"
            ></dx-button>
        </div>
        <div>
            <dx-button
                [disabled]="dataLoading || orderingMode"
                type="default"
                [stylingMode]="showOnlyBelowRop ? 'contained' : 'outlined'"
                text="Below ROP ({{ belowRopItemCount }})"
                [hint]="
                    orderingMode
                        ? 'Not applicable in ordering mode — it already shows only items that need ordering, which is a narrower set'
                        : 'Show only products with stock at or below their reorder point'
                "
                (onClick)="toggleBelowRopFilter()"
            ></dx-button>
        </div>
        <div>
            <dx-button
                [disabled]="dataLoading"
                stylingMode="contained"
                icon="columnchooser"
                hint="ตั้งค่าว่า View ไหนแสดงคอลัมน์อะไร"
                (onClick)="openColumnViews()"
            ></dx-button>
        </div>
        <div>
            <dx-button
                [disabled]="dataLoading"
                stylingMode="contained"
                icon="preferences"
                hint="Reorder settings (ROP / EOQ)"
                (onClick)="openConfig()"
            ></dx-button>
        </div>
        <div>
            <dx-button
                [disabled]="dataLoading || exporting"
                stylingMode="contained"
                icon="exportxlsx"
                hint="Export the visible columns and rows to Excel"
                (onClick)="exportExcel()"
            ></dx-button>
        </div>
        <div>
            <dx-button
                [disabled]="dataLoading"
                stylingMode="contained"
                icon="refresh"
                hint="Reload data"
                (onClick)="loadReorderingData()"
            ></dx-button>
        </div>
    </div>
    <!-- Hover tooltips. Kept OUTSIDE the flex toolbar: a dx-tooltip host
         element inside it would count as a flex item and add phantom gaps
         next to its target. -->
    <dx-tooltip
        target="#calcPeriodField"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
    >
        <div *dxTemplate="let tooltipData of 'content'" class="field-tooltip">
            Demand lookback window: sales from the last N days feed the ROP /
            EOQ calculations (minimum 30 days). Longer windows smooth noise
            but react slower to trend changes.
        </div>
    </dx-tooltip>
    <dx-tooltip
        target="#leadTimeField"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
    >
        <div *dxTemplate="let tooltipData of 'content'" class="field-tooltip">
            Supplier lead time: days from placing a purchase order until stock
            arrives. ROP = expected demand over this period + the class's
            safety stock, so longer lead times raise every reorder point.
        </div>
    </dx-tooltip>
    <dx-tooltip
        target="#demandForField"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
    >
        <div *dxTemplate="let tooltipData of 'content'" class="field-tooltip">
            Horizon for the Demand column: average daily sales × this many
            days. Display only — it does not affect ROP or EOQ.
        </div>
    </dx-tooltip>
    <dx-tooltip
        target="#abcClassInfo"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        [hideOnOutsideClick]="false"
    >
        <div
            *dxTemplate="let tooltipData of 'content'"
            class="class-info-tooltip"
        >
            Classes are <b>cumulative</b> 1-year-revenue bands (Pareto):
            <table class="class-info-table">
                <thead>
                    <tr>
                        <th>Class</th>
                        <th>Meaning</th>
                        <th class="num">Items</th>
                        <th class="num">Items&nbsp;%</th>
                    </tr>
                </thead>
                <tbody>
                    @for (row of classInfoRows; track row.cls) {
                    <tr>
                        <td class="cls">{{ row.cls }}</td>
                        <td>{{ row.desc }}</td>
                        <td class="num">{{ classCount(row.cls) }}</td>
                        <td class="num">{{ classItemPct(row.cls) }}</td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </dx-tooltip>
    @if (headerTooltipTarget) {
    <dx-tooltip
        [target]="headerTooltipTarget"
        [visible]="true"
        [hideOnOutsideClick]="false"
    >
        <div *dxTemplate="let tooltipData of 'content'" class="field-tooltip">
            {{ headerTooltipText }}
        </div>
    </dx-tooltip>
    }

    <dx-data-grid
        #dataGrid
        id="reorderingGrid"
        height="100%"
        [dataSource]="dataSource"
        [showBorders]="true"
        keyExpr="_id"
        [focusedRowEnabled]="false"
        [columnAutoWidth]="false"
        [allowColumnResizing]="true"
        [showRowLines]="true"
        [rowAlternationEnabled]="true"
        [hoverStateEnabled]="true"
        (onCellPrepared)="onCellPrepared($event)"
        (onCellHoverChanged)="onCellHoverChanged($event)"
        (onContextMenuPreparing)="onContextMenuPreparing($event)"
        (onContentReady)="onGridContentReady()"
        (onEditingStart)="onEditingStart($event)"
        (onCellDblClick)="onCellDblClick($event)"
        (onRowUpdating)="onRowUpdating($event)"
        (onRowUpdated)="onRowUpdated()"
    >
        <dxo-filter-panel [visible]="true"></dxo-filter-panel>
        <dxo-filter-builder> </dxo-filter-builder>
        <dxo-filter-builder-popup [width]="400" title="Inventory Filter">
        </dxo-filter-builder-popup>
        <!-- pageSize is computed from the grid height (fitPageSizeToHeight),
             so the manual page-size selector is hidden. -->
        <dxo-paging [pageSize]="20"></dxo-paging>
        <dxo-pager [showPageSizeSelector]="false" [showInfo]="true"></dxo-pager>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-state-storing
            [enabled]="true"
            type="custom"
            [customSave]="saveGridState"
            [customLoad]="loadGridState"
            [savingTimeout]="500"
        ></dxo-state-storing>
        <!-- Cell mode (not batch): each edit commits into the row object on
             blur, so the computed Total column live-updates. What is editable
             is enforced in onEditingStart: Order Qty (ordering mode only) and
             ROP (double-click, any mode). -->
        <dxo-editing
            mode="cell"
            [allowUpdating]="true"
            [selectTextOnEditStart]="true"
        ></dxo-editing>
        <div *dxTemplate="let cellData of 'relativeDatetimeCellTemplate'">
            {{ cellData.value | formatRelativeDatetime }}
        </div>
        <dxi-column
            [width]="120"
            caption="Last Updated"
            dataField="crawler_last_updated"
            [calculateCellValue]="convertLastUpdateDatetimeToMoment"
            cellTemplate="relativeDatetimeCellTemplate"
        ></dxi-column>
        <dxi-column dataField="sku" caption="SKU" [width]="100"></dxi-column>
        <dxi-column
            dataField="title"
            caption="Product Title"
            [minWidth]="120"
            cellTemplate="titleTemplate"
        ></dxi-column>
        <dxi-column
            dataField="class"
            caption="Class"
            [width]="85"
            alignment="center"
        ></dxi-column>
        <dxi-column
            dataField="price.$numberDecimal"
            [width]="95"
            caption="Unit Price"
            dataType="number"
            cellTemplate="priceTemplate"
        ></dxi-column>
        <dxi-column
            dataField="total_sale"
            caption="1Y Rev."
            [width]="90"
            dataType="number"
            cellTemplate="priceTemplate"
        ></dxi-column>
        <dxi-column
            dataField="demand"
            [width]="125"
            caption="Demand ({{ demandForDays }}D)"
            dataType="number"
            cellTemplate="numTemplate"
        ></dxi-column>
        <dxi-column
            dataField="remain"
            [width]="120"
            caption="Current Stock"
            dataType="number"
            cellTemplate="numTemplate"
        ></dxi-column>
        <dxi-column
            dataField="stock_cover_days"
            caption="Cover (Days)"
            [width]="110"
            dataType="number"
            cellTemplate="numTemplate"
        ></dxi-column>
        <dxi-column
            dataField="turnover"
            caption="Turnover /yr"
            [width]="105"
            dataType="number"
            cellTemplate="priceTemplate"
        ></dxi-column>
        <!-- Turnover's denominator and its provenance. -->
        <dxi-column
            dataField="avg_stock"
            caption="Avg Stock"
            [width]="100"
            dataType="number"
            cellTemplate="priceTemplate"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            dataField="snapshot_days"
            caption="Snapshot Days"
            [width]="115"
            dataType="number"
            cellTemplate="numTemplate"
            [visible]="false"
        ></dxi-column>
        <!-- Which of these columns show is applied from the component: see
             applyActiveView and isColumnVisible. -->
        <dxi-column
            dataField="on_order_qty"
            caption="On Order"
            [width]="95"
            dataType="number"
            [visible]="false"
            [allowEditing]="false"
            cellTemplate="numTemplate"
        ></dxi-column>
        <!-- Ordering-mode columns: never persisted (stripped in
             saveGridState/loadGridState). -->
        <dxi-column
            dataField="order_qty"
            caption="Order Qty"
            [width]="100"
            dataType="number"
            [visible]="false"
            [editorOptions]="{
                min: 0,
                format: '#,##0',
                showSpinButtons: false
            }"
        ></dxi-column>
        <dxi-column
            dataField="projected_total"
            caption="Total"
            [width]="90"
            dataType="number"
            [visible]="false"
            [allowEditing]="false"
            [calculateCellValue]="calculateProjectedTotal"
            cellTemplate="numTemplate"
        ></dxi-column>
        <dxi-column
            dataField="rop"
            [width]="100"
            caption="ROP"
            dataType="number"
            cellTemplate="priceTemplate"
            sortOrder="desc"
            [editorOptions]="{ min: 0, showSpinButtons: false }"
        ></dxi-column>
        <dxi-column
            dataField="eoq_units"
            [width]="100"
            caption="EOQ"
            dataType="number"
            cellTemplate="numTemplate"
        ></dxi-column>
        <!-- 1688: what to buy and where. -->
        <dxi-column
            dataField="supplier.label"
            caption="1688"
            [width]="240"
            [visible]="false"
            [allowEditing]="false"
            cellTemplate="supplierTemplate"
        ></dxi-column>
        <dxi-column
            dataField="supplier.shopName"
            caption="Shop"
            [width]="130"
            [visible]="false"
            [allowEditing]="false"
        ></dxi-column>
        <dxi-column
            dataField="supplier.costCny"
            caption="Last ¥"
            [width]="75"
            dataType="number"
            [visible]="false"
            [allowEditing]="false"
            cellTemplate="priceTemplate"
        ></dxi-column>
        <dxi-column
            dataField="supplier.lastOrderDate"
            caption="Last Bought"
            [width]="100"
            [visible]="false"
            [allowEditing]="false"
        ></dxi-column>
        <!-- Every remaining API metric, for column views to pick from (see
             temp/*.md for the field contracts). -->
        <dxi-column
            dataField="_id"
            caption="PID"
            [width]="80"
            dataType="number"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            dataField="stock_status"
            caption="Stock Status"
            [width]="110"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            dataField="product_type"
            caption="Product Type"
            [width]="110"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            dataField="unit_sold"
            caption="Units Sold"
            [width]="100"
            dataType="number"
            cellTemplate="numTemplate"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            dataField="data_days"
            caption="Data Days"
            [width]="100"
            dataType="number"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            dataField="demand_std_dev"
            caption="σ Demand/Day"
            [width]="115"
            dataType="number"
            cellTemplate="priceTemplate"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            dataField="safety_stock"
            caption="Safety Stock"
            [width]="110"
            dataType="number"
            cellTemplate="priceTemplate"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            dataField="sale_share"
            caption="Rev. Share"
            [width]="100"
            dataType="number"
            [format]="{ type: 'percent', precision: 2 }"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            dataField="annual_demand"
            caption="Annual Demand"
            [width]="120"
            dataType="number"
            cellTemplate="numTemplate"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            dataField="unit_value"
            caption="Unit Cost (est.)"
            [width]="115"
            dataType="number"
            cellTemplate="priceTemplate"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            dataField="annual_holding_cost_per_unit"
            caption="Holding/Unit/Yr"
            [width]="125"
            dataType="number"
            cellTemplate="priceTemplate"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            dataField="eoq"
            caption="EOQ (raw)"
            [width]="100"
            dataType="number"
            cellTemplate="priceTemplate"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            dataField="orders_per_year"
            caption="Orders/Year"
            [width]="105"
            dataType="number"
            cellTemplate="priceTemplate"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            dataField="order_cycle_days"
            caption="Cycle Days"
            [width]="100"
            dataType="number"
            cellTemplate="numTemplate"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            dataField="total_annual_variable_cost"
            caption="Annual Var. Cost"
            [width]="125"
            dataType="number"
            cellTemplate="priceTemplate"
            [visible]="false"
        ></dxi-column>
        <dxi-column
            dataField="note"
            caption="Note"
            [minWidth]="140"
            [visible]="false"
        ></dxi-column>
        <div *dxTemplate="let cellData of 'priceTemplate'">
            {{ cellData.value | formatNumber : 2 }}
        </div>
        <div *dxTemplate="let cellData of 'numTemplate'">
            {{ cellData.value | formatNumber : 0 }}
        </div>
        <div *dxTemplate="let cellData of 'titleTemplate'" class="title-cell">
            @if (cellData.data.pause_reason; as reason) {
            <span class="pause-badge" [title]="reason">หยุดสั่ง</span>
            }
            <a
                [href]="`https://a.lnwstore.com/arduino4/inventory/product/${cellData.data._id}/`"
                target="_blank"
                (click)="$event.stopPropagation()"
                [title]="cellData.value"
                class="grid-link-ellipsis"
            >
                {{ cellData.value }}
            </a>
        </div>
        <div *dxTemplate="let cellData of 'supplierTemplate'">
            @if (cellData.data.supplier; as supplier) {
            <app-supplier-1688-links
                [supplier]="supplier"
            ></app-supplier-1688-links>
            }
        </div>
    </dx-data-grid>
</div>

<app-column-views-popup
    #columnViewsPopup
    [saving]="columnViewsSaving"
    (save)="saveColumnViews($event)"
></app-column-views-popup>

<app-supplier-1688-editor
    #supplierEditor
    (saved)="onSupplierOverridesSaved($event)"
></app-supplier-1688-editor>

<dx-popup
    [(visible)]="configPopupVisible"
    [showTitle]="true"
    title="Reorder Settings"
    [dragEnabled]="true"
    [hideOnOutsideClick]="!configSaving"
    (onHidden)="onConfigPopupHidden()"
    [width]="440"
    height="auto"
>
    <div class="config-form">
        <div class="config-field">
            <div class="config-row">
                <dx-number-box
                    label="Service Level A"
                    labelMode="floating"
                    format="#0%"
                    [min]="0.5"
                    [max]="0.999"
                    [step]="0.05"
                    [(value)]="serviceLevelA"
                ></dx-number-box>
                <dx-number-box
                    label="Service Level B"
                    labelMode="floating"
                    format="#0%"
                    [min]="0.5"
                    [max]="0.999"
                    [step]="0.05"
                    [(value)]="serviceLevelB"
                ></dx-number-box>
                <dx-number-box
                    label="Service Level Other"
                    labelMode="floating"
                    format="#0%"
                    [min]="0.5"
                    [max]="0.999"
                    [step]="0.05"
                    [(value)]="serviceLevelOther"
                ></dx-number-box>
            </div>
            <div class="config-hint">
                Cycle service level sizing each product's ROP safety stock,
                per ABC class (Other = C/D/N). 50% ⇒ no safety stock (reorder
                at plain demand × lead time); higher (e.g. 90%) adds buffer
                against stock-outs during the lead time, so top classes carry
                more protection than the long tail.
            </div>
        </div>
        <div class="config-field">
            <dx-number-box
                label="Ordering Cost / order (฿)"
                labelMode="floating"
                format="#,##0"
                [min]="1"
                [(value)]="orderingCost"
            ></dx-number-box>
            <div class="config-hint">
                EOQ “S” — the fixed cost to place one order (admin, freight,
                handling). Higher ordering cost ⇒ larger, less frequent orders.
            </div>
        </div>
        <div class="config-field">
            <dx-number-box
                label="Holding Rate (per year)"
                labelMode="floating"
                format="#0%"
                [min]="0.01"
                [step]="0.05"
                [(value)]="holdingRate"
            ></dx-number-box>
            <div class="config-hint">
                EOQ carrying cost as a fraction of unit value per year (e.g. 25%
                / yr). Higher holding rate ⇒ smaller, more frequent orders.
            </div>
        </div>
        <div class="config-field">
            <dx-number-box
                label="Cost Ratio (cost ÷ list price)"
                labelMode="floating"
                format="#0%"
                [min]="0.01"
                [max]="1"
                [step]="0.05"
                [(value)]="costRatio"
            ></dx-number-box>
            <div class="config-hint">
                Converts list (selling) price to a cost basis for EOQ: unit
                value = list price × ratio. There is no COGS in the data, so use
                e.g. 60% to approximate cost at 60% of list.
            </div>
        </div>
        <div class="config-actions">
            <dx-button
                stylingMode="outlined"
                text="Apply"
                hint="Use these settings now (not saved)"
                [disabled]="configSaving"
                (onClick)="applyConfig()"
            ></dx-button>
            <dx-button
                stylingMode="contained"
                type="default"
                text="Save as Default"
                hint="Save these settings for next time"
                [disabled]="configSaving"
                (onClick)="saveConfig()"
            ></dx-button>
        </div>
    </div>
</dx-popup>

<dx-popup
    [(visible)]="saveOrderPopupVisible"
    [showTitle]="true"
    title="Save Purchase Order"
    [dragEnabled]="true"
    [hideOnOutsideClick]="!orderSaving"
    [width]="400"
    height="auto"
>
    <div class="config-form">
        <div class="config-hint">
            {{ pendingLines.length }} items · {{ pendingUnits }} units
        </div>
        <dx-text-box
            label="Label / supplier (optional)"
            labelMode="floating"
            [(value)]="orderLabel"
            [showClearButton]="true"
            (onEnterKey)="confirmSaveOrder()"
        ></dx-text-box>
        <div class="config-actions">
            <dx-button
                stylingMode="outlined"
                text="Cancel"
                [disabled]="orderSaving"
                (onClick)="saveOrderPopupVisible = false"
            ></dx-button>
            <dx-button
                stylingMode="contained"
                type="default"
                text="Save Order"
                [disabled]="ordersBusy"
                (onClick)="confirmSaveOrder()"
            ></dx-button>
        </div>
    </div>
</dx-popup>

<dx-popup
    [(visible)]="pauseLongPopupVisible"
    [showTitle]="true"
    title="Pause long term"
    [dragEnabled]="true"
    [hideOnOutsideClick]="!orderSaving"
    [width]="400"
    height="auto"
>
    <div class="config-form">
        <div class="config-hint">
            {{ pauseLongRow?.sku }} · {{ pauseLongRow?.title }}
        </div>
        <dx-text-box
            label="เหตุผลที่พัก (ไม่บังคับ)"
            labelMode="floating"
            [(value)]="pauseLongReason"
            [showClearButton]="true"
            (onEnterKey)="confirmPauseLong()"
        ></dx-text-box>
        <div class="config-actions">
            <dx-button
                stylingMode="outlined"
                text="Cancel"
                [disabled]="orderSaving"
                (onClick)="pauseLongPopupVisible = false"
            ></dx-button>
            <dx-button
                stylingMode="contained"
                type="default"
                text="Pause"
                [disabled]="ordersBusy"
                (onClick)="confirmPauseLong()"
            ></dx-button>
        </div>
    </div>
</dx-popup>

<dx-popup
    [(visible)]="ordersPopupVisible"
    [showTitle]="true"
    title="Purchase Orders"
    [dragEnabled]="true"
    [hideOnOutsideClick]="true"
    [width]="1200"
    maxWidth="96vw"
    height="75vh"
>
    <!-- A template so nothing below is built until the popup first opens. -->
    <div *dxTemplate="let popupData of 'content'" class="orders-popup-content">
    <dx-scroll-view height="100%">
        <div class="orders-list">
            @if (supplierIndex.dataThrough; as dataThrough) {
            <div class="config-hint">
                Grouped by the 1688 shop of each product's last order. Last ¥ and
                totals are what was paid then, excluding shipping, from orders up
                to {{ dataThrough }}. Check the price on the offer page.
            </div>
            }
            @for (order of ordersSorted; track order.id) {
        <div class="order-card" [class.completed]="order.status === 'completed'">
            <div class="order-head">
                <span class="order-id">{{ order.id }}</span>
                @if (order.label) {
                <span class="order-label">{{ order.label }}</span>
                }
                <span class="order-meta">
                    {{ order.lines.length }} items ·
                    {{ orderUnits(order) }} units ·
                    @let view = orderSupplierViews[order.id];
                    @if (view?.shopCount) {
                    {{ view.shopCount }}
                    {{ view.shopCount === 1 ? 'shop' : 'shops' }} · ≈ ¥{{
                        view.estimateCny | formatNumber : 2
                    }}
                    @if (view.unpricedLines) {
                    ({{ view.unpricedLines }} not priced)
                    }
                    ·
                    }
                    created
                    {{ order.created_at | formatRelativeDatetime }}
                    @if (order.completed_at) { · completed
                    {{ order.completed_at | formatRelativeDatetime }}
                    }
                </span>
                @if (order.status === 'open') {
                <dx-button
                    stylingMode="contained"
                    type="default"
                    text="Done"
                    hint="Goods received — stop counting this order toward on-order stock"
                    [disabled]="ordersBusy"
                    (onClick)="completeOrder(order)"
                ></dx-button>
                } @else {
                <dx-button
                    stylingMode="outlined"
                    text="Reopen"
                    hint="Undo complete — count this order toward on-order stock again"
                    [disabled]="ordersBusy"
                    (onClick)="reopenOrder(order)"
                ></dx-button>
                }
                <dx-button
                    icon="trash"
                    stylingMode="text"
                    hint="Delete this order permanently"
                    [disabled]="ordersBusy"
                    (onClick)="deleteOrder(order)"
                ></dx-button>
            </div>
            <table class="order-lines">
                <thead>
                    <tr>
                        <th class="sku">SKU</th>
                        <th>Product</th>
                        <th class="supplier">1688</th>
                        <th class="num price">Last ¥</th>
                        <th class="num">Qty</th>
                        <th
                            class="num on-1688"
                            title="What to enter on 1688: Qty × the 1688 units in one store unit"
                        >
                            On 1688
                        </th>
                        <th class="line-actions"></th>
                    </tr>
                </thead>
                <tbody>
                    @for (group of view?.groups; track group.shopUrl) {
                    <tr class="shop-row">
                        <td colspan="7">
                            @if (group.shopUrl; as shopUrl) {
                            <a
                                class="supplier-link"
                                [href]="shopUrl"
                                target="_blank"
                                rel="noopener noreferrer"
                                >{{ group.shopName }}</a
                            >
                            <span class="shop-meta"
                                >{{ group.lines.length }} items · ≈ ¥{{
                                    group.estimateCny | formatNumber : 2
                                }}
                                @if (group.unpricedLines) {
                                ({{ group.unpricedLines }} not priced)
                                }</span
                            >
                            } @else {
                            No 1688 data
                            <span class="shop-meta"
                                >{{ group.lines.length }} items</span
                            >
                            }
                        </td>
                    </tr>
                    @for (entry of group.lines; track entry.line.pid) {
                    @let line = entry.line;
                    @let supplier = entry.supplier;
                    <tr>
                        <td class="sku">{{ lineSku(line.pid) }}</td>
                        <td class="line-title">{{ lineTitle(line.pid) }}</td>
                        <td class="supplier">
                            @if (supplier) {
                            <app-supplier-1688-links
                                [supplier]="supplier"
                            ></app-supplier-1688-links>
                            }
                        </td>
                        <td class="num price">
                            {{ supplier?.costCny | formatNumber : 2 }}
                        </td>
                        @if (order.status === 'open') {
                        <td class="num">
                            <dx-number-box
                                [value]="line.qty"
                                [min]="1"
                                format="#,##0"
                                [width]="80"
                                [showSpinButtons]="false"
                                [disabled]="ordersBusy"
                                (onValueChanged)="
                                    onLineQtyChanged(order, line, $event)
                                "
                            ></dx-number-box>
                        </td>
                        } @else {
                        <td class="num">{{ line.qty }}</td>
                        }
                        <td
                            class="num on-1688"
                            [class.pack-differs]="supplier?.packed"
                        >
                            {{ entry.qtyText }}
                        </td>
                        <td class="line-actions">
                            @if (order.status === 'open') {
                            <dx-button
                                icon="trash"
                                stylingMode="text"
                                hint="Remove this item from the order"
                                [disabled]="ordersBusy"
                                (onClick)="removeOrderLine(order, line)"
                            ></dx-button>
                            }
                        </td>
                    </tr>
                    }
                    }
                </tbody>
            </table>
        </div>
            } @empty {
            <div class="config-hint">No purchase orders yet.</div>
            }
        </div>
    </dx-scroll-view>
    </div>
</dx-popup>
